import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { AxiosError } from 'axios';
import {
  ref, toRefs,
} from 'vue';
import { finalize } from 'rxjs/operators';
import userApiService from '@/api/userApiService';
import User from '@/models/User';
import Me from '@/modules/auth/data/MeInterface';
import useBaseValidation from '@/hooks/validation/useBaseValidation';
import { DialogEventType } from '@/common/Dialog';
import Dialog from '@/common/Dialog/Dialog.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordDialog',
  props: {
    user: {}
  },
  setup(__props: any) {

const props = __props;


const { required } = useBaseValidation();


const { t } = useI18n();

const { user } = toRefs(props);
const currentPassword = ref({
  password1: null,
  password2: null,
});

const form = ref(null);

const loading = ref(false);

const serverError = ref<{ [key: string]: string[] }>({});

const success = (data: User, onDialogOK: (payload?: User) => void) => {
  onDialogOK(data);
};

const errorHandler = (e: AxiosError<{ errors: { [key: string]: string[] } }>) => {
  loading.value = false;
  if (e.request.status === 422) {
    serverError.value = e.response.data.errors;
  } else {
    throw e;
  }
};

const onSave = ({ onDialogOK }: DialogEventType<User>) => {
  form.value.validate(true).then((status) => {
    if (status) {
      const { password1, password2 } = currentPassword.value;
      if (password1 === password2) {
        loading.value = true;
        const {
          username, phone, email, name, id,
        } = user.value;
        userApiService.edit(id, {
          name, email, phone, username, password: currentPassword.value.password1,
        })
          .pipe(finalize(() => {
            loading.value = false;
          })).subscribe(
            (data) => success(data, onDialogOK),
            errorHandler,
          );
      } else {
        serverError.value = { password: [t('changePassword.enterSamePassword')] };
      }
    }
  });
};


return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(Dialog, {
    title: _ctx.$t('personalAccount.changePassword'),
    width: 300,
    "loading-save-data": loading.value,
    onOnCancel: _cache[2] || (_cache[2] = ({ onDialogCancel }) => onDialogCancel()),
    onOnOk: onSave
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_form, {
        ref_key: "form",
        ref: form
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            ref: "pass1",
            modelValue: currentPassword.value.password1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword.value.password1) = $event)),
            class: "mb-3",
            type: "password",
            error: serverError.value.password && !!serverError.value.password.length,
            "error-message": serverError.value.password && serverError.value.password[0],
            rules: [_unref(required)],
            dense: "",
            label: _ctx.$t('login.password')
          }, null, 8, ["modelValue", "error", "error-message", "rules", "label"]),
          _createVNode(_component_q_input, {
            ref: "pass2",
            modelValue: currentPassword.value.password2,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPassword.value.password2) = $event)),
            type: "password",
            error: serverError.value.password && !!serverError.value.password.length,
            rules: [_unref(required)],
            dense: "",
            label: _ctx.$t('changePassword.repeatPassword')
          }, null, 8, ["modelValue", "error", "rules", "label"])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "loading-save-data"]))
}
}

})